import React, { createContext, useEffect, useState } from "react";
import { View } from "@frui.ts/views/dist";

import "assets/themes/default.theme.scss";
import "@edaz/edazkit/style.css";
import LoadingPane from "controls/loadingPane";
import Alert from "react-bootstrap/Alert";
import RootViewModel from "../viewModels/rootViewModel";
import * as Sentry from "@sentry/react";

export type PlainWidgetInitializer = () => Promise<RootViewModel | null>;
export type BoxWidgetProps = {
  init: PlainWidgetInitializer;
  identifier: string;
};

export const BoxWidgetContext = createContext<HTMLDivElement | null>(null);

const BoxWidgetView = ({ init, identifier }: BoxWidgetProps) => {
  const [viewModel, setViewModel] = useState<RootViewModel | null>(null);

  useEffect(() => {
    Sentry.setTags({
      widget: identifier,
      scope: `error-boundary-${identifier}`,
      release: "eshop-fe@" + process.env.REACT_APP_VERSION,
    });
  }, [identifier]);

  useEffect(() => {
    if (init && !viewModel) {
      init().then((model) => setViewModel(model));
    }
  }, [viewModel, init]);

  const outagesWidget = identifier === "edaz-outages";
  const children = viewModel ? <View vm={viewModel} useLifecycle /> : !outagesWidget && <LoadingPane />;

  return (
    <Sentry.ErrorBoundary
      key={identifier}
      fallback={
        <Alert variant="danger">
          {viewModel
            ? viewModel.localizationService.translateGeneral("errors.viewError")
            : "An unexpected error has occurred. Try to reload page."}
        </Alert>
      }>
      {outagesWidget ? children : <div id="root">{children}</div>}
    </Sentry.ErrorBoundary>
  );
};

export default BoxWidgetView;
